import { render, staticRenderFns } from "./Compatibility.vue?vue&type=template&id=02d792b6&scoped=true"
import script from "./Compatibility.vue?vue&type=script&lang=js"
export * from "./Compatibility.vue?vue&type=script&lang=js"
import style0 from "./Compatibility.vue?vue&type=style&index=0&id=02d792b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d792b6",
  null
  
)

export default component.exports